import { I18N_LANGUAGE_AVAILABLE, I18N_LANGUAGE_FALLBACK, I18N_NAMESPACE_FALLBACK, I18N_NAMESPACES, I18N_TRANSLATIONS_BASE_PATH, } from '../../constants/i18nConstants';
export const i18nConfigurationGeneral = {
    fallbackLng: I18N_LANGUAGE_FALLBACK,
    supportedLngs: I18N_LANGUAGE_AVAILABLE,
    load: 'all',
    // have a common namespace used around the full app
    // ns: ['account', 'brand', 'buy', 'checkout', 'form', 'general', 'navigation', 'product', 'social-sharing-bar', 'store'],
    ns: Object.values(I18N_NAMESPACES),
    defaultNS: I18N_NAMESPACE_FALLBACK,
    debug: false,
    compatibilityJSON: 'v1',
    keySeparator: '***',
    interpolation: {
        prefix: '{',
        suffix: '}',
        escapeValue: false, // not needed for react!!
    },
    react: {
        bindI18n: 'languageChanged loaded',
        nsMode: 'default',
        useSuspense: false,
    },
    backend: {
        // path where resources get loaded from, or a function
        // returning a path:
        // function(lngs, namespaces) { return customPath; }
        // the returned path will interpolate lng, ns if provided like giving a static path
        loadPath: I18N_TRANSLATIONS_BASE_PATH,
        // path to post missing resources
        addPath: I18N_TRANSLATIONS_BASE_PATH,
        // your backend server supports multiloading
        // /locales/resources.json?lng=de+en&ns=ns1+ns2
        allowMultiLoading: false, // set loadPath: '/locales/resources.json?lng={{lng}}&ns={{ns}}' to adapt to multiLoading
        // allow cross domain requests
        crossDomain: true,
        // allow credentials on cross domain requests
        withCredentials: false,
        // adds parameters to resource URL. 'example.com' -> 'example.com?v=1.3.5'
        queryStringParams: {},
    },
    cache: {
        // turn on or off
        enabled: false,
        // prefix for stored languages
        prefix: 'i18next_res_',
        // expiration
        expirationTime: 7 * 24 * 60 * 60 * 1000,
        // language versions
        versions: {},
    },
};
